// Senvè PDP gallery: hover-to-switch thumbnails, magnifier lens, modal thumbnail rail, mobile sticky Add to Cart.
document.addEventListener('DOMContentLoaded', () => {
  // 1. Hover a thumbnail switches the main image (desktop only, matches click behavior)
  document.querySelectorAll('media-gallery [id^="GalleryThumbnails"] [data-target] button').forEach((btn) => {
    btn.addEventListener('mouseenter', () => {
      if (window.matchMedia('(min-width: 750px)').matches) btn.click();
    });
  });

  // 2. Magnifier lens on the main product image.
  // The lens lives on <body> with position:fixed so it never depends on the
  // slider/carousel ancestor's positioning context, only on viewport coords.
  const magnifierLens = document.createElement('div');
  magnifierLens.className = 'senve-magnifier';
  magnifierLens.style.display = 'none';
  document.body.appendChild(magnifierLens);

  document.querySelectorAll('[id^="GalleryViewer"] .product__media-item').forEach((item) => {
    const img = item.querySelector('img');
    if (!img) return;

    item.addEventListener('mousemove', (e) => {
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      const rect = item.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        magnifierLens.style.display = 'none';
        return;
      }
      const zoom = 2.4;
      const lensSize = magnifierLens.offsetWidth || 180;
      magnifierLens.style.display = 'block';
      magnifierLens.style.left = `${e.clientX - lensSize / 2}px`;
      magnifierLens.style.top = `${e.clientY - lensSize / 2}px`;
      magnifierLens.style.backgroundImage = `url(${img.currentSrc || img.src})`;
      magnifierLens.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;
      magnifierLens.style.backgroundPosition = `-${x * zoom - lensSize / 2}px -${y * zoom - lensSize / 2}px`;
    });
    item.addEventListener('mouseleave', () => {
      magnifierLens.style.display = 'none';
    });
  });

  // 3. Thumbnail rail inside the product image modal (popup) - no prev/next
  // arrows, thumbnails are the only navigation.
  document.querySelectorAll('product-modal').forEach((modal) => {
    const dialog = modal.querySelector('.product-media-modal__dialog');
    const content = modal.querySelector('.product-media-modal__content');
    if (!dialog || !content) return;

    // Dawn's media-modal closes itself on any `pointerup` that isn't inside
    // a <deferred-media>/<product-model> (see ModalDialog in global.js) -
    // stop this custom control from bubbling that event up, or clicking a
    // thumbnail closes the whole lightbox instead of navigating.
    const keepModalOpen = (el) => el.addEventListener('pointerup', (e) => e.stopPropagation());

    let items = [];
    let thumbButtons = [];
    let classObserver = null;

    const setActive = (index) => {
      const activeIndex = items.findIndex((el) => el.classList.contains('active'));
      if (activeIndex !== -1) items[activeIndex].classList.remove('active');
      items[index].classList.add('active');
    };

    const syncThumbnails = () => {
      const activeIndex = items.findIndex((el) => el.classList.contains('active'));
      thumbButtons.forEach((btn, i) => {
        btn.classList.toggle('active', i === activeIndex);
        if (i === activeIndex) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
    };

    // Dawn replaces `.product-media-modal__content`'s entire innerHTML with
    // freshly-fetched markup whenever the selected variant changes (see
    // `product-info.js`), which would otherwise leave this rail pointing at
    // detached nodes. Rebuild it from scratch every time that happens
    // instead of capturing `items`/`thumbButtons` once.
    const buildThumbnails = () => {
      items = Array.from(content.querySelectorAll('[data-media-id]'));

      const existing = dialog.querySelector('.senve-modal-thumbnails');
      if (existing) existing.remove();

      const thumbnails = document.createElement('div');
      thumbnails.className = 'senve-modal-thumbnails';
      keepModalOpen(thumbnails);
      thumbButtons = items.map((item, index) => {
        const sourceImg = item.tagName === 'IMG' ? item : item.querySelector('img');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', `View image ${index + 1}`);
        if (sourceImg) {
          const thumbImg = document.createElement('img');
          thumbImg.src = sourceImg.currentSrc || sourceImg.src;
          thumbImg.alt = sourceImg.alt || '';
          btn.appendChild(thumbImg);
        }
        btn.addEventListener('click', () => setActive(index));
        thumbnails.appendChild(btn);
        return btn;
      });
      dialog.appendChild(thumbnails);

      // Dawn sets the `active` class on the correct slide only once the
      // modal is actually opened (not at build time), so keep the rail in
      // sync reactively instead of computing it once.
      if (classObserver) classObserver.disconnect();
      classObserver = new MutationObserver(syncThumbnails);
      classObserver.observe(content, { attributes: true, attributeFilter: ['class'], subtree: true });
      syncThumbnails();
    };

    buildThumbnails();
    new MutationObserver(buildThumbnails).observe(content, { childList: true });
  });

  // 4. Mobile sticky Add to Cart - appears once the visitor has scrolled
  // past the real button (not merely whenever it's off-screen, which would
  // include "haven't scrolled down to it yet"), disappears again once it's
  // back in view or the viewport is back above the mobile breakpoint.
  // Mirrors the real button's label/disabled state rather than assuming
  // "Add to cart" is always correct (e.g. sold-out variants).
  const stickyCta = document.querySelector('.senve-sticky-cta');
  if (stickyCta) {
    const sectionId = stickyCta.dataset.sectionId;
    const realButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    // On PDPs where the standard product form is replaced by the ritual
    // selector (Neck & Facial Massager) there is no ProductSubmitButton-*,
    // so the observer had nothing to watch and the bar never appeared. Fall
    // back to the selector's own add button: it is both the element the
    // visitor scrolls past and the one whose click runs add-to-cart, so a
    // plain click proxy keeps the selected tier + add-on state without this
    // file knowing anything about the selector's internals.
    const ritualButton = document.querySelector('[data-ritual-add-to-cart]');
    const anchorButton = realButton || ritualButton;
    const ritualTotal = document.querySelector('[data-ritual-total]');
    const stickyButton = stickyCta.querySelector('[data-senve-sticky-add]');
    const priceTarget = document.getElementById(`price-${sectionId}`);
    const stickyPrice = stickyCta.querySelector('.senve-sticky-cta__price');

    if (anchorButton) {
      const setVisible = (visible) => {
        stickyCta.classList.toggle('is-visible', visible);
        stickyCta.setAttribute('aria-hidden', String(!visible));
        stickyButton.tabIndex = visible ? 0 : -1;
      };
      setVisible(false);

      const syncButtonState = () => {
        stickyButton.disabled = anchorButton.disabled || anchorButton.getAttribute('aria-disabled') === 'true';
        stickyButton.classList.toggle('loading', anchorButton.classList.contains('loading'));
        // The ritual button's own label already carries the total ("Add to
        // Cart - $x"), which would duplicate the price shown beside it in
        // the bar, so there we keep the Liquid-rendered "Add to cart".
        if (!realButton) return;
        const label = realButton.querySelector('span:not(.sold-out-message)') || realButton;
        stickyButton.textContent = label.textContent.trim();
      };
      syncButtonState();
      new MutationObserver(syncButtonState).observe(anchorButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true,
      });

      if (!realButton && ritualTotal && stickyPrice) {
        // Ritual pages price the whole selection (tier x quantity + add-on),
        // so the product-level price block would understate what the button
        // actually adds. Mirror the selector's live total instead.
        const syncRitualPrice = () => {
          stickyPrice.textContent = ritualTotal.textContent.trim();
        };
        syncRitualPrice();
        new MutationObserver(syncRitualPrice).observe(ritualTotal, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      } else if (priceTarget && stickyPrice) {
        // The real price element renders regular/sale/unit-price markup
        // simultaneously and relies on Dawn's own CSS (scoped to `.price`'s
        // exact structure) to show only the relevant one - copying raw
        // `innerHTML` elsewhere reproduces the markup without that CSS
        // context and shows every price state stacked as text. Instead,
        // read whichever specific price-item is actually rendered visible
        // right now and mirror only its plain text.
        const syncPrice = () => {
          const candidates = priceTarget.querySelectorAll('.price-item--regular, .price-item--sale');
          const visible = Array.from(candidates).find(
            (el) => el.offsetParent !== null && getComputedStyle(el).display !== 'none'
          );
          stickyPrice.textContent = visible ? visible.textContent.trim() : '';
        };
        syncPrice();
        new MutationObserver(syncPrice).observe(priceTarget, { childList: true, subtree: true });
      }

      stickyButton.addEventListener('click', () => anchorButton.click());

      // Track "scrolled past" independently of viewport width so a resize
      // (e.g. rotating the device, or resizing a desktop window down past
      // the breakpoint) re-evaluates visibility in both directions instead
      // of only ever force-hiding on the way to desktop width.
      let scrolledPast = false;
      const observer = new IntersectionObserver(
        ([entry]) => {
          scrolledPast = entry.boundingClientRect.bottom < 0;
          setVisible(scrolledPast && window.matchMedia('(max-width: 749px)').matches);
        },
        { threshold: 0 }
      );
      observer.observe(anchorButton);

      window.addEventListener('resize', () => {
        setVisible(scrolledPast && window.matchMedia('(max-width: 749px)').matches);
      });
    }
  }
});
